import Vue from 'vue'
import VueRouter from 'vue-router'
import m_home from '../views/mobile/m_home.vue'
import m_menu from '../views/mobile/m_menu.vue'
import m_ooplist from '../views/mobile/m_ooplist.vue'
import m_detail from '../views/mobile/m_detail.vue'
import m_search from '../views/mobile/m_search.vue'

import pc_home from '../views/pc/pc_home.vue'
import pc_obj from '../views/pc/pc_obj.vue'
import pc_search from '../views/pc/pc_search.vue'
import pc_login from '../views/pc/pc_login.vue'
import pc_manage from '../views/pc/pc_manage.vue'
import pc_detail from '../views/pc/pc_detail.vue'

import about from '../views/About.vue'

Vue.use(VueRouter)

//解决重复报错问题
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}


const routes = [{
        path: '/m_home',
        name: 'm_home',
        component: m_home
    },
    {
        path: '/m_menu',
        name: 'm_menu',
        component: m_menu
    },
    {
        path: '/m_ooplist',
        name: 'm_ooplist',
        component: m_ooplist
    },
    {
        path: '/m_detail/:role/:articleID',
        name: 'm_detail',
        component: m_detail
    },
    {
        path: '/m_search',
        name: 'm_search',
        component: m_search
    },
    {
        path: '/PC_home',
        name: 'pc_home',
        component: pc_home
    },
    {
        path: '/pc_obj',
        name: 'pc_obj',
        component: pc_obj
    },
    {
        path: '/pc_search',
        name: 'pc_search',
        component: pc_search
    },
    {
        path: '/pc_detail/:role/:articleID',
        name: 'pc_detail',
        component: pc_detail
    },
    {
        path: '/login',
        name: 'pc_login',
        component: pc_login
    },

    {
        path: '/manage',
        name: 'pc_manage',
        component: pc_manage
    },
    {
        path: '/about',
        name: 'about',
        component: about
    },
    
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () =>
    //         import ( /* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router